import React from 'react'
import { subscription } from '../../../state'
import { CustomerIcon, ExpensesIcon, InvoiceIcon, ReportIcon } from '../../../assets/icons';

const SubscriptionUsage = ({subscriptionState}: {subscriptionState: subscription | null}) => {

  return (
    <div className='w-full lg:w-[1/2]'>
      <p className='word whitespace-nowrap'>Active Subscription Usage</p> 
      <div className='border border-1 border-[#DFDFDF] xl:h-[194px] rounded-[7px] flex gap-[30px] w-full  flex-col justify-between px-[12px] py-[12px] lg:px-[30px] lg:pt-[22px] lg:pb-[31px] mt-[12px]'>
         
        <div className='flex flex-col gap-[12px]'>

        <div className='flex justify-between'>
          <span className='flex'>
            <ExpensesIcon/>
            Expenses
          </span>
          <span>{subscriptionState?.usage?.expense}/{subscriptionState?.limits?.expense}</span>
         </div>

         <div className='flex justify-between'>
          <span className='flex'>
            <InvoiceIcon/>
            Invoices
          </span>
          <span>{subscriptionState?.usage?.invoice}/{subscriptionState?.limits?.invoice}</span>
         </div>

         <div className='flex justify-between'>
          <span className='flex'>
            <ReportIcon/>
            Reports
          </span>
          <span>{subscriptionState?.usage?.reports}/{subscriptionState?.limits?.reports}</span>
         </div>

         <div className='flex justify-between'>
          <span className='flex'>
            <CustomerIcon/>
            Customers
          </span>
          <span>{subscriptionState?.usage?.customers}/{subscriptionState?.limits?.customers}</span>
         </div>
        
        </div> 
         
     </div>

    </div>
  )
}

export default SubscriptionUsage